import { useInfiniteQuery } from 'react-query';
import getHistory from 'data/requests/getHistory';
import { History } from 'model/history';
import { HistoryQueryParams } from 'data/types/history';

const useHistory = (params: HistoryQueryParams) => {
  const {
    data,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery<History>(['history', params], () => getHistory(params));

  const orders = (data?.pages || []).flatMap(
    (history: History) => history.orders,
  );

  return {
    orders,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  };
};

export default useHistory;
